import Icons from "../../../../resources/icons/Icons";
import classes from "./SelectedTokenCard.module.css";

const SelectedTokenCard = (props) => {
  return (
    <div className={classes.selectedTokenCard}>
      <div className={classes.selectedTokenContainer}>
        <img src={Icons.SCAN_SUCCESS} />
        <span>{props.text}</span>
      </div>
      {!props.isAssignedSuccess && <img
        src={Icons.DELETE_ITEM_2}
        className={classes.deleteIcon}
        onClick={props.handleDelete}
      />}
    </div>
  );
};
export default SelectedTokenCard;
